import { createContext, useContext } from "react";

/**
 * Contexto para la base de URLs de imágenes de la guía NY.
 * Cuando la guía es prebuilt (vista previa o importada), el Viewer proporciona
 * la URL del backend (ej. /api/prebuilt-guides/ny/assets/images/ny/) para que
 * todas las páginas carguen imágenes desde el backend y no desde el frontend.
 */
const ImageBaseUrlContext = createContext(null);

export const ImageBaseUrlProvider = ImageBaseUrlContext.Provider;

/**
 * @returns {string} Base URL para imágenes NY: la del contexto si existe, si no "/images/ny/"
 */
export function useImageBaseUrl() {
	const value = useContext(ImageBaseUrlContext);
	return value ?? "/images/ny/";
}

export default ImageBaseUrlContext;
